import { app } from '../../../../app';
import { Controller } from './login-services-form.controller';

app.component('loginServicesForm', {
    bindings: {
        loginServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&',
    },
    controller: Controller,
    templateUrl: require('./login-services-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/login-services-form.component.js